import BrandingThemeDetailsHeaderButtons from '@/components/brandingThemes/BrandingThemeDetailsHeaderButtons';
import MobileUIView from '@/components/brandingThemes/view/MobileUIView';
import ThemeNameView from '@/components/brandingThemes/view/ThemeNameView';
import WebsiteAndEmailsView from '@/components/brandingThemes/view/WebsiteAndEmailsView';
import WebsiteDemo from '@/components/brandingThemes/demos/WebsiteDemo';
import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { useGetBrandingThemeDetails } from '@/hooks/requests/useBrandingThemes';
import { Card, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function BrandingThemeView() {
  const { brandingThemeId = '' } = useParams();
  const { brandingTheme, isBrandingThemePending } =
    useGetBrandingThemeDetails(brandingThemeId);

  if (isBrandingThemePending) {
    return (
      <DefaultLayout header="">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!brandingTheme) {
    return (
      <DefaultLayout header="">
        <Card>
          <Typography>
            Something went wrong retreiving the branding theme. Our team has
            been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header={brandingTheme.name}
      buttons={[
        <BrandingThemeDetailsHeaderButtons
          key="header"
          brandingTheme={brandingTheme}
          showEdit
        />,
      ]}>
      <Stack spacing={2}>
        <ThemeNameView brandingTheme={brandingTheme} />
        <WebsiteAndEmailsView brandingTheme={brandingTheme} />
        <WebsiteDemo
          primaryColor={brandingTheme.primaryColor}
          secondaryColor={brandingTheme.secondaryColor}
          logoUrl={brandingTheme.logoUrl}
        />
        <MobileUIView brandingTheme={brandingTheme} />
      </Stack>
    </DefaultLayout>
  );
}
